import axios from 'axios';
import { BASE_URL } from './apiconfig';

/* ------------------------------------------------------------------ *
 * My API Keys — the authenticated user's own spas (customer surface). *
 * Backend: SpaApiKeyController (/spa-keys/manage, /spa-keys/{guid}).  *
 * ------------------------------------------------------------------ */

export const getMyApiKeys = async (token: string | null) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/spa-keys/manage`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull my API keys. ", error);
    throw error;
  }
};

export const generateMyApiKey = async (token: string | null, spaGuid: string) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/spa-keys/${spaGuid}`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to generate API key. ", error);
    throw error;
  }
};

export const revokeMyApiKey = async (token: string | null, spaGuid: string) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/spa-keys/${spaGuid}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to revoke API key. ", error);
    throw error;
  }
};

/* ------------------------------------------------------------------ *
 * Manage API Keys — every spa key in the system (manage_all_api_keys).*
 * Backend: AdminApiKeyController (/admin/api-keys).                   *
 * ------------------------------------------------------------------ */

export const getAllApiKeys = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/admin/api-keys?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to pull all API keys. ", error);
    throw error;
  }
};

export const generateApiKeyAdmin = async (token: string | null, spaGuid: string) => {
  try {
    const { data } = await axios.post(`${BASE_URL}/admin/api-keys`, { spa_guid: spaGuid }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to generate API key. ", error);
    throw error;
  }
};

export const revokeApiKeyAdmin = async (token: string | null, apikey: string) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/admin/api-keys/${apikey}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to revoke API key. ", error);
    throw error;
  }
};
